// icons
import { FiGithub, FiLinkedin, FiMail, FiMapPin } from "react-icons/fi";

// navegación
export const navigation = [
  {
    name: "Inicio",
    href: "home",
  },
  {
    name: "Sobre mí",
    href: "about",
  },
  {
    name: "Proyectos",
    href: "portfolio",
  },
  {
    name: "Contacto",
    href: "contacto",
  },
];

// redes sociales
export const social = [
  {
    icon: <FiLinkedin />,
    href: "https://www.linkedin.com/in/kimberly-blandon/",
  },
  {
    icon: <FiGithub />,
    href: "https://github.com/Kimblag",
  },
];

// proyectos
export const projectsData = [
  {
    id: "1",
    name: "Motor de Matching Semántico",
    stack: "NestJS · TypeScript · MongoDB",
    problem:
      "La comparación manual entre requerimientos técnicos y catálogos de productos es lenta, subjetiva y propensa a errores.",
    approach:
      "Diseño de arquitectura por capas con NestJS, generación de embeddings y separación estricta entre dominio e infraestructura para garantizar mantenibilidad.",
    result:
      "Reducción del tiempo de análisis de horas a minutos y mejora en consistencia y trazabilidad de resultados.",
    href: "https://github.com/Kimblag/semantic_product_search",
  },
];

// contacto
export const contact = [
  {
    icon: <FiMail />,
    title: "¿Quieres colaborar?",
    subtitle: "Estoy disponible para proyectos y oportunidades.",
    description: "kimberly.blandong@gmail.com",
  },
  {
    icon: <FiMapPin />,
    title: "Ubicación",
    subtitle: "Buenos Aires, Argentina",
    description: "Trabajo con equipos y clientes de forma remota.",
  },
];
